interface OptionsConfigStrings {
  app_prefix: string
  scrollOffset: number
  refreshIntervalTimeMS: number
}

export class OptionsConfig {
  public static get strings(): OptionsConfigStrings {
    return {
      app_prefix: 'hs_client',
      scrollOffset: 5,
      refreshIntervalTimeMS: 5 * 1000,
    }
  }

  public static get stringsInventory(): OptionsConfigStrings {
    return {
      app_prefix: 'hs_client',
      scrollOffset: 5,
      refreshIntervalTimeMS: 5 * 1000,
    }
  }
}
